import { Module } from "vuex";

import { RootStateType } from "@/store";

import actions from "./actions";
import mutations from "./mutations";
import { DataImplementationState } from "./model";

let state: DataImplementationState = {
  dataImplementation: {
    id: '',
    name: '',
    description: '',
    localId: '',
    remarks: '',
    controllerId: '',
    publishing: false,
    dataComponentModelId: '',
    dataComponentModelName: '',
    processOperationImplementationsCount: 0,
    parameterDescription: '',
  },
  dataImplementations: [],
  messages: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
} as Module<DataImplementationState, RootStateType>;
